import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import Backend from 'i18next-http-backend';

// Langues supportées (Phase 1 : 5 langues principales)
export const supportedLngs = ['fr', 'en', 'es', 'de', 'it'] as const;
export const defaultLng = 'fr';

export type Locale = (typeof supportedLngs)[number];

// Noms des langues pour l'affichage
export const localeNames: Record<Locale, string> = {
  fr: 'Français',
  en: 'English',
  es: 'Español',
  de: 'Deutsch',
  it: 'Italiano',
};

// Drapeaux pour le Language Switcher
export const localeFlags: Record<Locale, string> = {
  fr: '🇫🇷',
  en: '🇬🇧',
  es: '🇪🇸',
  de: '🇩🇪',
  it: '🇮🇹',
};

// Namespaces de traduction
export const namespaces = [
  'common',      // Navigation, footer, boutons, etc.
  'home',        // Page d'accueil
  'blog',        // Articles de blog
  'formations',  // Catalogue formations
  'prestations', // Services/prestations
  'contact',     // Formulaire contact
  'seo',         // Meta tags, descriptions
  'auth',        // Authentification (login, magic link)
  'profile',     // Page profil utilisateur
  'admin',       // Dashboard admin
] as const;

i18n
  .use(Backend) // Chargement dynamique depuis /public/locales/{lng}/{ns}.json
  .use(LanguageDetector) // Détection auto de la langue (navigateur, localStorage)
  .use(initReactI18next) // React binding
  .init({
    fallbackLng: defaultLng,
    supportedLngs: [...supportedLngs],
    defaultNS: 'common',
    ns: [...namespaces],

    // Configuration Backend
    backend: {
      loadPath: '/locales/{{lng}}/{{ns}}.json',
    },

    // Configuration LanguageDetector
    detection: {
      order: ['path', 'localStorage', 'navigator'],
      caches: ['localStorage'],
      lookupFromPathIndex: 0, // /fr/blog → fr
    },

    // Interpolation
    interpolation: {
      escapeValue: false, // React already escapes
    },

    // React
    react: {
      useSuspense: true,
    },
  });

export default i18n;
